﻿<template>
	<div class="container-fluid" v-cloak>

		<div class="row mt-5">

			<div class="col-md-3">
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<form id="formContact" name="formContact" v-show="showForm">
						<h2 class="font-md-blue">Contact Us</h2>
						<p class="font-xs-black">We'll get back to you as soon as we can.</p>
						<input id="email" class="form-control mt-3" type="email" maxlength="50" placeholder="Email" v-model="email">
						<span class="text-danger" v-show="showEmailWarning">Valid email address is required.</span>
						<input id="name" class="form-control mt-3" type="text" maxlength="50" placeholder="Name" v-model="name">
						<span class="text-danger" v-show="showNameWarning">Name is required.</span>
						<input id="subject" class="form-control mt-3" type="text" maxlength="100" placeholder="Subject" v-model="subject">
						<span class="text-danger" v-show="showSubjectWarning">Subject is required.</span>
						<textarea id="message" class="form-control mt-3" type="text" maxlength="5000" placeholder="Your message..." v-model="message"></textarea>
						<span class="text-danger" v-show="showMessageWarning">Message is required.</span>
						<input id="btnSubmit" class="btn btn-primary w-100 mt-3" type="button" value="Submit" :disabled="disableSubmit" @click="sendMessage">
					</form>
					<div class="contact-success mt-3" v-show="successAfterSubmit">
						<p>Thanks. We've received your request. We will get in touch with you as soon as we can!</p>
					</div>
					<div class="contact-fail mt-3" v-show="failureAfterSubmit">
						<p>Something went wrong!</p>
						<p>Please try again at a later time.</p>
						<p>Optionally, try emailing us at contact(at)contentbase(dot)com.</p>
					</div>
				</div>
			</div>

			<div class="col-md-3">
			</div>

		</div>

	</div>
</template>




<script>
	import { mixinAxios } from '@/js/shared/VueMixins.js';
	import { isNotNullOrWhiteSpace } from '@/js/shared/utils';
	export default {
		mixins: [mixinAxios],
		data: () => ({
			emailInput: false,
			nameInput: false,
			subjectInput: false,
			messageInput: false,
			email: '',
			name: '',
			subject: '',
			message: '',
			submitted: false,
			brevoSuccess: false
		}),
		methods: {
			sendMessage() {
				var msg = {
					Email: this.email,
					Name: this.name,
					Subject: this.subject,
					Message: this.message
				};

				var reqSendMessage = this.mixinAxios().post('/api/guest/SendSupportRequest', msg).then((resSendMessage) => {
					var mailSent = resSendMessage.data;
					this.submitted    = mailSent;
					this.brevoSuccess = mailSent;
				});
			}
		},
		computed: {
			emailValid() {
				var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return re.test(String(this.email).toLowerCase());
			},
			nameValid() {
				return isNotNullOrWhiteSpace(this.name);
			},
			subjectValid() {
				return isNotNullOrWhiteSpace(this.subject);
			},
			messageValid() {
				return isNotNullOrWhiteSpace(this.message);
			},
			allInputsValid() {
				return (this.emailValid && this.nameValid && this.subjectValid && this.messageValid);
			},
			disableSubmit() {
				return (this.requestActive || !this.allInputsValid);
			},
			notYetSubmitted() {
				return !this.submitted;
			},
			successAfterSubmit() {
				return (this.submitted && this.brevoSuccess);
			},
			failureAfterSubmit() {
				return (this.submitted && !this.brevoSuccess);
			},
			showEmailWarning() {
				return (this.emailInput && !this.emailValid);
			},
			showNameWarning() {
				return (this.nameInput && !this.nameValid);
			},
			showSubjectWarning() {
				return (this.subjectInput && !this.subjectValid);
			},
			showMessageWarning() {
				return (this.messageInput && !this.messageValid);
			},
			showForm() {
				return (this.notYetSubmitted || this.failureAfterSubmit);
			}
		},
		watch: {
			email(newVal, oldVal) {
				this.emailInput = true;
			},
			name(newVal, oldVal) {
				this.nameInput = true;
			},
			subject(newVal, oldVal) {
				this.subjectInput = true;
			},
			message(newVal, oldVal) {
				this.messageInput = true;
			}
		}
	}
</script>




<style scoped>
	[v-cloak] {
		display: none;
	}

	#message {
		height: 200px;
	}

	input:focus, textarea:focus {
		box-shadow: 0 0 0 0.25rem rgba(67, 56, 202, 0.25);
		border:1px solid rgb(206, 212, 218);
	}

	.contact-success, .contact-fail {
		text-align:center;
	}

	.contact-success p {
		font-size: 1.25em;
	}

	.contact-fail p {
		font-size: 1.25em;
		color: red;
	}
</style>